import React from "react";
import Unauthorized from "./Unauthorized";
import SessionTimeoutWarningModal from "./Modals/SessionTimeoutWarningModal";
import useSessionTimeout from "../hooks/useSessionTimeout";
import { SESSION_MESSAGES } from "../constants/Session";

// Wraps the chat so an expired session takes the whole page down: every
// action (messages, appointment accept/decline, edits) unmounts with it and
// the Stream user disconnects with AppSettingsProvider. Before that, an idle
// user (or one whose silent renewal failed) gets the warning prompt.
const SessionTimeoutGate = ({ children }) => {
  const session = useSessionTimeout();

  if (session.sessionExpired) {
    return <Unauthorized errorMessage={SESSION_MESSAGES.EXPIRED} />;
  }

  return (
    <>
      {children}
      <SessionTimeoutWarningModal
        isOpen={session.isWarningVisible}
        reason={session.warningReason}
        secondsLeft={session.secondsLeft}
        isRenewing={session.isRenewing}
        onContinue={session.continueSession}
        onCancel={session.dismissWarning}
      />
    </>
  );
};

export default SessionTimeoutGate;
